import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

import { GET_INCOMPLETERIDE } from '../../actions';

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      completedride:'',
      editable: false,
      priorityid:'',
      priorityvalue:'',
	   activePage: 1,
	   totalRecord: '',
	   search_all:''
    };
	
	var qs = require('qs');
	var postobject = {
		activePage: 1,
    historytype:'incompleted',
		search_all: '',
    admin_id: localStorage.getItem('admin_id')
	};
    this.props.getIncompleteRide(qs.stringify(postobject));
	
	
	 this.handleInputChange = this.handleInputChange.bind(this);
	 this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
   componentDidMount() {
      document.title = PageTitle('Ongoing List');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }


   componentWillReceiveProps(Props){
	if(Props.incompleteride !== this.props.incompleteride){
		if(Object.keys(Props.incompleteride).length > 0){
			this.setState({totalRecord : Props.incompleteride[0].records_count})
		}
	}
		
   }

deletevehicle(id){
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          car_id  :id
        };
      this.props.getDeleteCar(qs.stringify(postObject));
}
handleChange = (name,carid,event) => {
  console.log(carid)
  this.setState({priorityid: name,priorityvalue: event.target.value})
   var qs = require('qs');
        var postObject = {
          value :event.target.value,
          car_id  :carid
    };
  this.props.getPriorityUpdate(qs.stringify(postObject));
}



handlePageChange(pageNumber) {
   // console.log(`active page is ${pageNumber}`);
    this.setState({activePage: pageNumber});
    var qs = require('qs');
	var postobject = {
		activePage: pageNumber,
    historytype:'incompleted',
		search_all: this.state.search_all,
    admin_id: localStorage.getItem('admin_id')
	};
	this.props.getIncompleteRide(qs.stringify(postobject))
  }
  
handleInputChange(event) {
  const {name, value} = event.target;      
  this.setState({
	  [name]: value
	});
  
}
 handleFormSubmit = () => {
			
				this.setState({Loading:true});
				var qs = require('qs');
				const formPayload = this.state;
			   
				var postObject = {			       
					activePage   : 1,
          historytype:'incompleted',
					search_all : formPayload.search_all,
          admin_id: localStorage.getItem('admin_id')					
				};
			  this.props.getIncompleteRide(qs.stringify(postObject));
			
	}  
  
  
  vehiclelist() {
    var incompleteride = this.props.incompleteride[0];
    if (incompleteride != "undefined" && incompleteride != null) {
      if (incompleteride.status == "success") {
        if (Object.keys(incompleteride).length > 0) {
          const vehiclelistDetails = incompleteride.records.map(
            (incompleteride, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={incompleteride.id}>
                <td>{sno}</td>
                  <td> {incompleteride.firstname?incompleteride.firstname:'Guest User'}</td>
                  <td>{incompleteride.booking_id}</td>
                  <td>{incompleteride.from_location}</td>
                  <td>{incompleteride.to_location}</td>
                  <td>{incompleteride.driver_fname != ''?incompleteride.driver_fname:"-"}</td>
                  <td>{incompleteride.driver_mobile != ''?incompleteride.driver_mobile:"-"}</td>
                  <td>Incomplete</td>
                   <td>{incompleteride.car_name}</td>
                   <td>${incompleteride.car_price}</td>
                 {/* <td className="actiongroup">
                    <Link to={{ pathname: '/car/view/'+bookinglist.id}} className="" title="view">  <i className="fa fa-eye" aria-hidden="true"></i></Link>
                   <Link onClick={this.deletevehicle.bind(this,bookinglist.id)} className="" title="Delete">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                   
                   
                  </td>*/}
                </tr>
              );
            }
          );
          return vehiclelistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="10" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }
  
  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="incompleteride" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Incomplete Rides</h3>
                </div>
				<div className="search-list">
				 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
				  <div className="search-inner">
						<input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" />				  
				   <button className="" type="submit">Submit</button>
					<div className="erroremail"></div>
				</div>
				   
				  </form>
                </div>
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Rider Name</th>
                      <th>Booking ID</th>
                      <th>From Location</th>                      
                      <th>To Location</th>
          					  <th>Driver Info</th>
          					  <th>Driver Mobile</th>
          					  <th>Ride Status</th>
                      <th>Selected Car</th>
                      <th>Ride Amount</th>
                     
                    </tr>
                  </thead>
                  <tbody>{this.vehiclelist()}</tbody>
                </Table>
          	     <div className="text-center">
          				 <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.totalRecord}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                  />
          		</div>
          </div>
         </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    incompleteride: state.incompleteride,
  }
  
}

const mapDispatchToProps = (dispatch) => {
  return {
    getIncompleteRide: (formVal) =>{
       dispatch({ type: GET_INCOMPLETERIDE, formVal });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));